// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputSearchWrapper__qau_s {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
}

.searchIconBlock__eeraF {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.searchIcon__Wv7uo {
  width: auto;
  height: auto;
}
.searchIcon__Wv7uo path {
  stroke: var(--buttons-surface);
}

.searchResetBlock__cs34l {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.searchResetIcon__GXPHs {
  cursor: pointer;
  width: 10px;
  height: 10px;
}
.searchResetIcon__GXPHs path {
  stroke: var(--map-surface-default);
}

.inputSearch__yWh0Q {
  border: none;
  flex: 1;
  height: 100%;
  outline: 0;
  box-shadow: none;
  background: none;
  color: var(--inputs-search-text-filled);
  padding: unset;
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}
.inputSearch__yWh0Q::placeholder {
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0%;
  color: var(--inputs-search-text-placeholer);
}

.headerInputSearchWrapper__EeTcV {
  background: var(--inputs-search-surface-default);
}
.headerInputSearchWrapper__EeTcV .searchResetIcon__GXPHs {
  width: 13px;
  height: 13px;
}

.tableInputSearchWrapper__HMOF_ {
  padding: 5px 8px;
  background: var(--inputs-search-surface-table);
  border-radius: 5px;
  height: 35px;
}
.tableInputSearchWrapper__HMOF_:focus-within {
  border: 1px solid var(--inputs-focus-stroke);
}`, "",{"version":3,"sources":["webpack://./../src/components/uikit/FilterSearch/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;AAzEF;AA2EE;EACE,8BAAA;AAzEJ;;AA6EA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA1EF;;AA6EA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA1EF;AA4EE;EACE,kCAAA;AA1EJ;;AA8EA;EACE,YAAA;EACA,OAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,cAAA;EACA,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA3EF;AA6EE;EACE,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,2CAAA;AA3EJ;;AA+EA;EACE,gDAAA;AA5EF;AA8EE;EACE,WAAA;EACA,YAAA;AA5EJ;;AAgFA;EACE,gBAAA;EACA,8CAAA;EACA,kBAAA;EACA,YAAA;AA7EF;AA+EE;EACE,4CAAA;AA7EJ","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.inputSearchWrapper {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  position: relative;\n}\n\n.searchIconBlock {\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.searchIcon {\n  width: auto;\n  height: auto;\n\n  path {\n    stroke: var(--buttons-surface);\n  }\n}\n\n.searchResetBlock {\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.searchResetIcon {\n  cursor: pointer;\n  width: 10px;\n  height: 10px;\n\n  path {\n    stroke: var(--map-surface-default);\n  }\n}\n\n.inputSearch {\n  border: none;\n  flex: 1;\n  height: 100%;\n  outline: 0;\n  box-shadow: none;\n  background: none;\n  color: var(--inputs-search-text-filled);\n  padding: unset;\n  font-family: 'Roboto', sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n\n  &::placeholder {\n    font-family: 'Roboto', sans-serif;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    letter-spacing: 0%;\n    color: var(--inputs-search-text-placeholer);\n  }\n}\n\n.headerInputSearchWrapper {\n  background: var(--inputs-search-surface-default);\n\n  .searchResetIcon {\n    width: 13px;\n    height: 13px;\n  }\n}\n\n.tableInputSearchWrapper {\n  padding: 5px 8px;\n  background: var(--inputs-search-surface-table);\n  border-radius: 5px;\n  height: 35px;\n\n  &:focus-within {\n    border: 1px solid var(--inputs-focus-stroke);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputSearchWrapper": `inputSearchWrapper__qau_s`,
	"searchIconBlock": `searchIconBlock__eeraF`,
	"searchIcon": `searchIcon__Wv7uo`,
	"searchResetBlock": `searchResetBlock__cs34l`,
	"searchResetIcon": `searchResetIcon__GXPHs`,
	"inputSearch": `inputSearch__yWh0Q`,
	"headerInputSearchWrapper": `headerInputSearchWrapper__EeTcV`,
	"tableInputSearchWrapper": `tableInputSearchWrapper__HMOF_`
};
module.exports = ___CSS_LOADER_EXPORT___;
